export enum ButtonTheme {
  MATERIAL = 1,
  BOOTSTRAP = 2
}
